/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  HorizonInfo,
  HorizonToAddInfo,
  InterpretationToAddInfo,
  ObjectNameInfo,
  ProjectHorizonResponse,
} from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ProjectHorizonClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags ProjectHorizon
   * @summary Получение проектных горизонтов с интерпретацией по заданному кубу и горизонтов без интерпретаций
   * @request GET:/Seismic/project/{projectId}/horizon/withInterpretation/cube/{cubeId}
   * @secure
   */
  projectHorizonGetByProjectAndCubeId = (
    projectId: string,
    cubeId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<ProjectHorizonResponse[], any>({
      path: `/Seismic/project/${projectId}/horizon/withInterpretation/cube/${cubeId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectHorizon
   * @summary Получение проектных горизонтов с интерпретацией по заданной 2D съёмке и горизонтов без интерпретаций
   * @request GET:/Seismic/project/{projectId}/horizon/withInterpretation/survey2d/{surveyId}
   * @secure
   */
  projectHorizonGetByProjectAndSurvey2DId = (
    projectId: string,
    surveyId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<ProjectHorizonResponse[], any>({
      path: `/Seismic/project/${projectId}/horizon/withInterpretation/survey2d/${surveyId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectHorizon
   * @summary Получить горизонты по проекту
   * @request GET:/Seismic/project/{projectId}/horizon
   * @secure
   */
  projectHorizonGetHorizonsByProjectId = (projectId: string, params: RequestParams = {}) =>
    this.http.request<HorizonInfo[], any>({
      path: `/Seismic/project/${projectId}/horizon`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectHorizon
   * @summary Добавить горизонт к проекту
   * @request POST:/Seismic/project/{projectId}/horizon
   * @secure
   */
  projectHorizonAddHorizonToProject = (
    projectId: string,
    data: HorizonToAddInfo,
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, any>({
      path: `/Seismic/project/${projectId}/horizon`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectHorizon
   * @summary Добавить интерпретацию горизонта к проекту.
   * @request POST:/Seismic/project/{projectId}/horizon/interpretation
   * @secure
   */
  projectHorizonAddHorizonInterpretationToProject = (
    projectId: string,
    data: InterpretationToAddInfo,
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, any>({
      path: `/Seismic/project/${projectId}/horizon/interpretation`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectHorizon
   * @summary Переименовать горизонт
   * @request PUT:/Seismic/project/{projectId}/horizon/rename
   * @secure
   */
  projectHorizonRenameHorizon = (
    projectId: string,
    data: ObjectNameInfo,
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, any>({
      path: `/Seismic/project/${projectId}/horizon/rename`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectHorizon
   * @summary Копирование горизонта и его интепретаций
   * @request GET:/Seismic/project/{projectId}/horizon/copy/{horizonId}
   * @secure
   */
  projectHorizonCreateCopyHorizon = (
    projectId: string,
    horizonId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<string, any>({
      path: `/Seismic/project/${projectId}/horizon/copy/${horizonId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
}
